import * as React from "react";
import { useContext, useMemo, useState } from "react";
const ErrorsContext = React.createContext(null);
export function ErrorsProvider({ children }) {
  const [errors, setErrors] = useState();
  const value = useMemo(() => ({ errors, setErrors }), [errors, setErrors]);
  return /* @__PURE__ */ React.createElement(ErrorsContext.Provider, { value }, children);
}
export function useErrorsContext() {
  return useContext(ErrorsContext);
}
